export enum OriginatorActionType {
  CREATE_SLOC_FAILURE = '@@originator/CREATE_SLOC_FAILURE',
  CREATE_SLOC_REQUEST = '@@originator/CREATE_SLOC_REQUEST',
  CREATE_SLOC_SUCCESS = '@@originator/CREATE_SLOC_SUCCESS',

  GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_FAILURE = '@@originator/GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_FAILURE',
  GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_REQUEST = '@@originator/GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_REQUEST',
  GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_SUCCESS = '@@originator/GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_SUCCESS',

  GET_DEMAND_APIS_FAILURE = '@@originator/GET_DEMAND_APIS_FAILURE',
  GET_DEMAND_APIS_REQUEST = '@@originator/GET_DEMAND_APIS_REQUEST',
  GET_DEMAND_APIS_SUCCESS = '@@originator/GET_DEMAND_APIS_SUCCESS',

  GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_FAILURE = '@@originator/GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_FAILURE',
  GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_REQUEST = '@@originator/GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_REQUEST',
  GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_SUCCESS = '@@originator/GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_SUCCESS',
}
